export const GET_PHYSICAL_BREADCRUMBS = 'GET_PHYSICAL_BREADCRUMBS';
export const GET_QUERY_STATS = 'GET_QUERY_STATS';
